<template>
    <div class="shuffling_module_app">
        <mt-swipe :auto="4000">
            <mt-swipe-item class="shuffling_img_app" v-for="item in shufflingFunList" :key="item.id"
                @click.native="shufflingPicFun(item)">
                <img style="width:100%;height:14rem" :src="item.image_url" alt="">
                <p class="shuffling_img_title">{{ item.title }}</p>
            </mt-swipe-item>
        </mt-swipe>
    </div>
</template>
<script>
import { listApi, generateSign } from '@/api/index'
import Bus from '@/Bus'

const shufflingParameter = {
    pageNum: 0,
    pageSize: 10,
    columnId: "5cc57db80cf2c3d1b7e9d4e1",
    userId: "",
    appInfoId: "10"
}
const getNewsColumnData = {
    pageNum: 0,
    pageSize: 10,
    columnId: "5d68ce5de4b0e2963a408843",
    userId: "",
    appInfoId: "10"
}
export default {
    data() {
        return {
            shuParameter: Object.assign({}, shufflingParameter),
            getColumnData: Object.assign({}, getNewsColumnData),
            shufflingFunList: null,
            shufflingPicture: []
        }
    },
    created() {
        this.shufflingFun()
    },
    methods: {

        async shufflingFun() {
            const headers = {
                'Sign': generateSign()
            };
            const res = await this.axios.post(listApi, this.shuParameter, { headers })
            this.shufflingFunList = res.data.data[0].list.splice(0, 5)
        },
        shufflingPicFun(type) {
            this.$router.push({ path: '/listDetailsApp', query: { id: type.id, jsonUrl: type.jsonUrl, typeNum: 1, url: type.url } })
        }
    }
}
</script>
<style lang="">
    .shuffling_module_app{
        height:14rem;
    }
    .shuffling_module_app .mint-swipe-indicator{
        background: #fff;
        opacity: 1;
    }
    .shuffling_module_app .is-active{
        background: rgb(206, 2, 2) !important;
    }
    .shuffling_img_app{
        position: relative;
    }
    .shuffling_img_app .shuffling_img_title{
        position:absolute;
        bottom:0;
        /* font-size: 0.26rem; */
        color:#fff;
        text-align: center;
        width:94%;
        padding:0.6rem 3% 0;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        height:3rem;
        background:rgba(19, 18, 18, 0.445);
    }
</style>


// WEBPACK FOOTER //
// src/components/appModule/shufflingApp/index.vue